import _toConsumableArray from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { keys } from '../util';
import { parseData as _parseData } from './data/parse';
import { assembleLayoutSignals as _assembleLayoutSignals } from './layoutsize/assemble';
import { Model } from './model';
export var BaseConcatModel =
/*#__PURE__*/
function (_Model) {
  _inherits(BaseConcatModel, _Model);

  function BaseConcatModel(spec, specType, parent, parentGivenName, config, repeater, resolve) {
    _classCallCheck(this, BaseConcatModel);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaseConcatModel).call(this, spec, specType, parent, parentGivenName, config, repeater, resolve));
  }

  _createClass(BaseConcatModel, [{
    key: "parseData",
    value: function parseData() {
      this.component.data = _parseData(this);
      this.children.forEach(function (child) {
        child.parseData();
      });
    }
  }, {
    key: "parseSelections",
    value: function parseSelections() {
      var _this = this;

      // Merge selections up the hierarchy so that they may be referenced
      // across unit specs. Persist their definitions within each child
      // to assemble signals which remain within output Vega unit groups.
      this.component.selection = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var child = _step.value;
          child.parseSelections();
          keys(child.component.selection).forEach(function (key) {
            _this.component.selection[key] = child.component.selection[key];
          });
        };

        for (var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "parseMarkGroup",
    value: function parseMarkGroup() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var child = _step2.value;
          child.parseMarkGroup();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "parseAxesAndHeaders",
    value: function parseAxesAndHeaders() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.children[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var child = _step3.value;
          child.parseAxesAndHeaders();
        } // TODO(#2415): support shared axes

      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: "assembleSelectionTopLevelSignals",
    value: function assembleSelectionTopLevelSignals(signals) {
      return this.children.reduce(function (sg, child) {
        return child.assembleSelectionTopLevelSignals(sg);
      }, signals);
    }
  }, {
    key: "assembleSignals",
    value: function assembleSignals() {
      this.children.forEach(function (child) {
        return child.assembleSignals();
      });
      return [];
    }
  }, {
    key: "assembleLayoutSignals",
    value: function assembleLayoutSignals() {
      return this.children.reduce(function (signals, child) {
        return [].concat(_toConsumableArray(signals), _toConsumableArray(child.assembleLayoutSignals()));
      }, _assembleLayoutSignals(this));
    }
  }, {
    key: "assembleSelectionData",
    value: function assembleSelectionData(data) {
      return this.children.reduce(function (db, child) {
        return child.assembleSelectionData(db);
      }, data);
    }
  }, {
    key: "assembleMarks",
    value: function assembleMarks() {
      // only children have marks
      return this.children.map(function (child) {
        var title = child.assembleTitle();
        var style = child.assembleGroupStyle();
        var encodeEntry = child.assembleGroupEncodeEntry(false);
        return Object.assign({
          type: 'group',
          name: child.getName('group')
        }, title ? {
          title: title
        } : {}, style ? {
          style: style
        } : {}, encodeEntry ? {
          encode: {
            update: encodeEntry
          }
        } : {}, child.assembleGroup());
      });
    }
  }]);

  return BaseConcatModel;
}(Model);